import { Link } from "react-router-dom";
import { Linkedin, Instagram, Dribbble } from "lucide-react";

const explore = [
  { to: "/work", label: "Work" },
  { to: "/services", label: "Services" },
  { to: "/process", label: "Process" },
  { to: "/about", label: "About" },
  { to: "/insights", label: "Insights" },
  { to: "/contact", label: "Contact" },
];

const serviceLinks = ["Strategy", "Web Design", "Development", "Branding", "Optimization"];

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#08090B]">
    <div className="mx-auto max-w-7xl px-6 py-16 sm:px-8 lg:px-12">
      <div className="grid gap-12 md:grid-cols-[2fr_1fr_1fr_1fr]">
        <div>
          <Link to="/" data-testid="footer-wordmark" aria-label="Kronos home" className="flex items-center gap-3">
            <img src="/kronos-mark-light.webp" alt="" className="h-10 w-auto" />
            <span className="font-display text-lg font-bold tracking-[0.4em] text-[#F4F4F6]">KRONOS</span>
          </Link>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#5A5E6B]">
            Designed for what comes next.
          </p>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#5A5E6B]">Explore</p>
          <ul className="mt-5 space-y-3">
            {explore.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-sm text-[#9498A4] transition-colors hover:text-[#F4F4F6]"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#5A5E6B]">Services</p>
          <ul className="mt-5 space-y-3">
            {serviceLinks.map((s) => (
              <li key={s}>
                <Link to="/services" className="text-sm text-[#9498A4] transition-colors hover:text-[#F4F4F6]">
                  {s}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#5A5E6B]">Connect</p>
          <div className="mt-5 flex gap-3">
            {[
              { icon: Linkedin, label: "LinkedIn" },
              { icon: Instagram, label: "Instagram" },
              { icon: Dribbble, label: "Dribbble" },
            ].map(({ icon: Icon, label }) => (
              <a
                key={label}
                href="#"
                aria-label={label}
                data-testid={`footer-social-${label.toLowerCase()}`}
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/10 text-[#9498A4] transition-colors hover:border-[#2563EB]/50 hover:text-[#F4F4F6]"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
          <div className="mt-6 space-x-5 text-sm text-[#5A5E6B]">
            <span>Privacy</span>
            <span>Terms</span>
            <Link to="/admin" data-testid="footer-admin-link" className="transition-colors hover:text-[#F4F4F6]">Admin</Link>
          </div>
        </div>
      </div>
      <div className="mt-16 flex flex-col justify-between gap-3 border-t border-white/5 pt-8 text-xs text-[#5A5E6B] sm:flex-row">
        <span>© Kronos. All rights reserved.</span>
        <span className="font-mono uppercase tracking-[0.25em]">Make every second of attention count</span>
      </div>
    </div>
  </footer>
);
